<template>
  <window-container>
    <div style="font-size:18px;padding:10px;">INV#{{ $route.params.id }}&nbsp;Payment</div>
    <div class="po-payment card">
      <table class="detail-table">
        <tr>
          <th>INV No.</th>
          <th>Company</th>
          <th>Payment Terms</th>
          <th>Date</th>
          <th>Delivery Date</th>
          <th>Sales</th>
        </tr>
        <tr>
          <td>INV&nbsp;CYS{{ doc.id }}</td>
          <td>{{ doc.company_name }}</td>
          <td>{{ doc.payment_terms }}</td>
          <td>{{ doc.doc_date }}</td>
          <td>{{ doc.delivery_date }}</td>
          <td>{{ doc.sales_name}}</td>
        </tr>
      </table>
      <div style="margin:20px 0;font-weight:bold;">
        Amount:&nbsp;{{ doc.currency }}&nbsp;{{ doc.total_charge }}&nbsp;&nbsp;&nbsp;&nbsp;
        Balance:&nbsp;{{ doc.currency }}&nbsp;{{ balance }}
      </div>
      <table class="detail-table">
        <tr>
          <th>Received</th>
          <th>{{ doc.currency }}</th>
          <th>Remark</th>
          <th>Date</th>
          <th>Bank</th>
          <th>By</th>
        </tr>
        <tr v-for="(item, index) in paymentList" :key="item.id">
          <td>{{ index + 1 }}</td>
          <td><number-input v-model.number="paymentList[index].amount" class="input-number" style="width:80px;"></number-input></td>
          <td><el-input v-model="paymentList[index].remark" style="width:200px;"></el-input></td>
          <td>
            <el-date-picker v-model="paymentList[index].pay_date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width:150px;"></el-date-picker>
          </td>
          <td>
            <el-select v-model="paymentList[index].bank" style="width:100px;">
              <el-option label="HSBC HK" value="HSBC HK"></el-option>
              <el-option label="BOC HK" value="BOC HK"></el-option>
            </el-select>
          </td>
          <td>
            <el-select v-model="paymentList[index].sales_id" style="width:120px;">
              <el-option v-for="item in salesList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
            </el-select>
          </td>
        </tr>
        <tr>
          <td colspan="6" style="text-align:left;">
            <el-button type="primary" icon="el-icon-plus" @click="add"></el-button>
          </td>
        </tr>
      </table>
      <div style="text-align:center;margin:20px;">
        <el-button type="primary" @click="save">Save</el-button>
        <el-button type="info" style="margin-left:10px;" @click="$close()">Cancel</el-button>
      </div>
    </div>
  </window-container>
</template>

<script>
import moment from 'moment'
import NP from 'number-precision'
import NumberInput from '@/components/NumberInput.vue'
export default {
  components: {
    NumberInput
  },
  data () {
    return {
      doc: {},
      paymentList: [],
      paymentTotal: 0
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    salesList () {
      return this.$store.state.select.sales
    },
    balance () {
      return NP.minus(this.doc.total_charge, this.paymentTotal)
    }
  },
  mounted () {
    this.fetchDoc()  
    this.fetchPayment()
    this.$store.dispatch('fetchSelect', 'sales')
  },
  methods: {
    fetchDoc () {
      this.$http.get('/dbapi/pi_doc_list?id=' + this.$route.params.id).then(data => {
        this.doc = data.list[0]
      })
    },
    fetchPayment () {
      this.$http.get('/dbapi/pi_payment_list?order_id=' + this.$route.params.id).then(data => {
        this.paymentList = data.list
        this.sumTotal()
        this.add()
      })
    },
    add () {
      this.paymentList.push({
        amount: 0,
        remark: '',
        pay_date: moment().format('YYYY-MM-DD'),
        bank: 'HSBC HK',
        sales_id: this.user.id
      })
    },
    sumTotal () {
      let total = 0
      for (let i = 0; i < this.paymentList.length; i++) {
        total = NP.plus(total, parseFloat(this.paymentList[i].amount))
      }
      this.paymentTotal = total
    },
    save () {
      this.$http.post('/dbapi/pi_payment_insert', {
        order_id: this.$route.params.id,
        payments: this.paymentList.filter(r => r.amount > 0)
      }).then(data => {
        this.$message({
          type: 'success',
          message: '保存成功!'
        })
        this.sumTotal()
        window.opener && window.opener.postMessage('cystron', '*') // 刷新主页列表
      })
    }
  }
}
</script>


<style lang="scss">
.po-payment {
  table {
    width: 100%;
    border-spacing: 0;
  }
  .detail-table {
    border-spacing: 0;
    width: 100%;
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    th {
      padding: 4px;
      text-align: center;
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
      background-color: #ccc;
    }
    td {
      font-size: 14px;
      padding: 4px;
      text-align: center;
      border-right: 1px solid #000;
      border-bottom: 1px solid #000;
    }
  }
  .input-number {
    .el-input__inner {
      text-align: right;
    }
  }
}
</style>


